export interface IVrsAccordionConfig {
  allowMultipleActiveItems: boolean;
}

function isIterable<T = any>(x: any): x is Iterable<T> {
  return typeof x?.[Symbol.iterator] === "function";
}

export function accordionDataContext(config: Partial<IVrsAccordionConfig>) {
  const { allowMultipleActiveItems } = Object.assign(
    {
      allowMultipleActiveItems: false,
    } as IVrsAccordionConfig,
    config,
  );
  return {
    allowMultipleActiveItems,
    activeItems: new Set<HTMLElement>(),

    isActive(item: HTMLElement) {
      document.querySelectorAll;
      return this.activeItems.has(item);
    },

    open(item: HTMLElement | Iterable<HTMLElement>) {
      if (!this.allowMultipleActiveItems) {
        this.activeItems.clear();
      }
      if (isIterable(item)) {
        for (const i of item) {
          this.activeItems.add(i);
        }
      } else {
        this.activeItems.add(item);
      }
    },

    close(item: HTMLElement | HTMLElement[]) {
      if (Array.isArray(item)) {
        for (const i of item) {
          this.activeItems.delete(i);
        }
      } else {
        this.activeItems.delete(item);
      }
    },

    toggle(item: HTMLElement) {
      if (this.isActive(item)) {
        this.close(item);
        return;
      }
      this.open(item);
    },
  };
}
